import React from "react";

const SCSecurityFace = () => {
  return (
    <div style={{ color: "white", fontFamily: "Arial, sans-serif" }}>
      <h2 style={{ color: "#ff0055", borderBottom: "2px solid #ff0055", paddingBottom: "10px" }}>
        🛡️ SC Security Auditor
      </h2>
      
      <p style={{ marginTop: "15px", opacity: 0.9 }}>
        Especialista en auditoría de seguridad y análisis de vulnerabilidades en Smart Contracts para prevenir exploits y asegurar los fondos de los usuarios.
      </p>

      <div style={{ marginTop: "20px" }}>
        <h3 style={{ color: "#ff0055", fontSize: "16px" }}>Expertise:</h3>
        <ul style={{ fontSize: "14px", opacity: 0.8 }}>
          <li>Análisis Estático y Dinámico (Slither, Mythril).</li>
          <li>Pruebas de Invariantes y Fuzzing (Echidna/Foundry).</li>
          <li>Mitigación de ataques de Reentrancy, Front-running y Lógica.</li>
        </ul>
      </div>

      {/* SECCIÓN DE PRODUCTO RELACIONADO */}
      <div style={{ 
        marginTop: "25px", 
        padding: "15px", 
        background: "rgba(255, 0, 85, 0.1)", 
        borderRadius: "12px", 
        border: "1px dashed #ff0055" 
      }}>
        <h4 style={{ margin: "0 0 10px 0", color: "#ff0055", fontSize: "14px" }}>🛠️ FrancoLab Security Tools:</h4>
        <p style={{ fontSize: "13px", margin: "0 0 10px 0" }}>
          <strong>Audit-Vault:</strong> Repositorio abierto de reportes de auditoría y patrones de vulnerabilidades Web3.
        </p>
        <a 
          href="#" 
          style={{ color: "#ff0055", fontSize: "13px", fontWeight: "bold", textDecoration: "none" }}
        >
          Leer Reportes de Auditoría →
        </a>
      </div>
    </div>
  );
};

export default SCSecurityFace;